import React from 'react';
import { MapPin, Award, Briefcase } from 'lucide-react';
import { Badge } from './ui/badge';

const Hero = ({ profile }) => {
  return (
    <section id="hero" className="pt-32 pb-20 bg-gradient-to-br from-slate-50 via-white to-teal-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <Badge className="bg-teal-100 text-teal-800 hover:bg-teal-200 border-teal-200">
                Pediatric Specialist
              </Badge>
              
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
                {profile?.nameWithCredentials || profile?.name}
              </h1>
              
              <p className="text-xl sm:text-2xl text-slate-600 font-medium">
                {profile?.title}
              </p>
              
              <div className="flex flex-wrap items-center gap-6 pt-4">
                <div className="flex items-center space-x-2 text-slate-600">
                  <MapPin className="w-5 h-5 text-teal-600" />
                  <span className="font-medium">{profile?.location}</span>
                </div>
                <div className="flex items-center space-x-2 text-slate-600">
                  <Briefcase className="w-5 h-5 text-teal-600" />
                  <span className="font-medium">{profile?.about?.experience} Experience</span>
                </div>
              </div>
              
              <div className="flex flex-wrap gap-2 pt-4">
                {profile?.about?.qualifications?.map((qual, idx) => (
                  <Badge key={idx} variant="outline" className="text-sm border-slate-300 text-slate-700">
                    {qual}
                  </Badge>
                ))}
              </div>
              
              <div className="flex flex-wrap gap-4 pt-6">
                <a href="#hospital" className="inline-flex">
                  <button className="px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl">
                    View Hospital Affiliation
                  </button>
                </a>
                <a href="#expertise" className="inline-flex">
                  <button className="px-8 py-3 bg-white text-teal-600 font-semibold rounded-lg border-2 border-teal-600 hover:bg-teal-50 transform hover:scale-105 transition-all duration-200">
                    View Expertise
                  </button>
                </a>
              </div>
            </div>
            
            {/* Right Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-300">
                <img
                  src={profile?.image}
                  alt={profile?.name}
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;